import barba from '@barba/core';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){
        barba.hooks.beforeEnter((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        const strs = document.querySelectorAll("[data-str-anim]")
        if(strs.length > 0){
            strs.forEach((el)=>{
                let pr_str = el.textContent.split("");
                let str = "";
                pr_str.map( s => {
                    str += "<span class='str--split'>" + s  + "</span>";
                })
                
                el.innerHTML = str;
            })
        }
        // if(strs.length > 0){
        //     strs.forEach( title => {
        //         const t = title.querySelectorAll('.str--split')
        //         gsap.to(t, {
        //             //y: 0,
        //             //scale: 1,
        //             stagger: 0.05,
        //             opacity: 1,
        //             duration: 2.1,
        //             scrollTrigger: {
        //                 trigger: title,
        //                 start: 'top bottom 25%',
        //                 end: 'bottom top',
        //                 onEnter: () => {
        //                     gsap.set(t, { opacity: 0 });
        //                 },
        //             }
        //         }); 
        //     })
        // }
        // if (strs.length > 0) {
        //     strs.forEach((title) => {
        //       const t = title.querySelectorAll(".str--split");
        //       let isActive = false; // アニメーションが実行中かどうかのフラグ
        
        //       gsap.set(t, { opacity: 0 }); // 初期状態を非表示に設定
        
        //       ScrollTrigger.create({
        //         trigger: title,
        //         start: "top bottom",
        //         end: "bottom top",
        //         onEnter: () => {
        //           if (!isActive) {
        //             gsap.to(t, {
        //               opacity: 1,
        //               stagger: 0.05,
        //               duration: 0.90,
        //             });
        //             isActive = true; // アニメーションが実行中であることを設定
        //           }
        //         },
        //         onLeaveBack: () => {
        //           gsap.set(t, { opacity: 0 }); // 下から上にスクロールして画面外に出たら非表示にする
        //           gsap.killTweensOf(t); // アニメーションをリセット
        //           isActive = false; // アニメーションが終了したことを設定
        //         },
        //       });
        //     });
        //   }
    }
}